import { Anchor, Icon, Referenz } from 'components/atoms';
import React, { memo } from 'react';
import type { NetzwerkDto } from 'types';
import { Referenz as ReferenzType } from 'types';

import BrutkastenAnteil from './BrutkastenAnteil';
import css from './BrutkastenBeteiligungen.module.scss';
import WatermarkLogo from './WatermarkLogo';


export interface BeteiligungsProps 
{
  netzwerk: NetzwerkDto;
  origin: ReferenzType;
  date: Date | null;
}

const BrutkastenBeteiligungen: React.FC<BeteiligungsProps> = (props) => 
{
  const { origin, netzwerk, date } = props;

  const gesellschafter = [...netzwerk.gesellschafter];

  const utmString = '?utm_source=brutkasten&utm_medium=captable&utm_campaign=media_cooperation_brutkasten';

  return (
    <div className={css.graphContainer}>

      <Referenz data={{ ...origin, isIndexed: true }}>
        {({ href }) => (
          <>
            {/* Origin */}
            <div className={css.origin}>
              <span>{date == null ? 'Tagesaktuelle' : 'Historische'} Gesellschafter:innen von</span>
              <a
                href={href + utmString}
                target={'_blank'}
              >
                {origin.name}<Icon name={'externalLink'}/>
              </a>
              <span>Stand vom {date == null ? new Date().toLocaleDateString('de') : date.toLocaleDateString('de')}</span>
            </div>

            {/* Gesellschafter */}
            {gesellschafter.length > 0 && (
              <ol className={css.list}
                // @ts-ignore
                  onClick={() => window.open(href + utmString, '_blank').focus()}>
                {gesellschafter.map((g) => <BrutkastenAnteil key={g.key} item={g}/>)}
              </ol>
            )}

          </>
        )}
      </Referenz>

      <Anchor href={'/' + utmString} variant={'subtle'} target={'_blank'}>
        <div className={css.watermark}>
          Ein Service von
          <WatermarkLogo/>
        </div>
      </Anchor>

    </div>
  )
  ;
};

export default memo(BrutkastenBeteiligungen);
